import { AlertColor } from '@mui/material';
import { createContext } from 'react';

export interface IAlert {
  type: AlertColor;
  i18nKey: string;
  error?: Error;
  highPriority?: boolean;
  horizontalPosition?: 'center' | 'left' | 'right';
  autoHideDuration?: number;
}

export interface IAlertContext {
  enqueueAlert: (alert: IAlert) => void;
}

const initialProps: IAlertContext = {
  enqueueAlert: () => console.log('notImplemented'),
};

export const AlertContext = createContext<IAlertContext>(initialProps);
